module.exports = __webpack_public_path__ + "media/en_gb_s3_Hailey.aa64ee9f.mp3";